import React, { Component, useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap'

const ConfirmationModal = (props) => {
    const [show, setShow] = useState(true);

    // useEffect(() => {
    //     console.log('confirmation Modal');
    //     if (props.isShowModal) {
    //         handleShow()
    //     }
    //     else {
    //         handleClose()
    //     }
    // });

    const handleClose = () => {
        setShow(false)

    };
    const handleShow = () => {
        setShow(true);
    }

    let deleteItem = () => {
        alert()
        props.callback('delete')
    }



    return (
        <Modal show={show} onHide={() => props.callback('hide')}>
            {/* <Modal.Header closeButton>
                <Modal.Title>Delete?</Modal.Title>
            </Modal.Header> */}
            <Modal.Body>Are you sure you want to delete?</Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => props.callback('hide')}>
                    Close
                </Button>
                <Button variant="danger" onClick={() => props.callback('delete')}>
                    Delete
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmationModal;